import React from "react";
import { CloseIcon } from "../icons";

// Shared overlay + header for the page's jv2-style modals. Clicking the backdrop closes
// the modal unless `closeOnBackdrop` is false.
const ModalShell = ({ title, titleStyle, maxWidth, onClose, closeOnBackdrop = true, children }) => (
  <div className="jv2-modal-overlay" onClick={closeOnBackdrop ? onClose : undefined}>
    <div className="jv2-modal" style={{ maxWidth }} onClick={(e) => e.stopPropagation()}>
      <div className="jv2-modal-head">
        <h3 style={titleStyle}>{title}</h3>
        <button className="jv2-modal-close" onClick={onClose}><CloseIcon /></button>
      </div>
      {children}
    </div>
  </div>
);

export default ModalShell;
